import { render, staticRenderFns } from "./BoxTabularData.vue?vue&type=template&id=cd14f730&scoped=true&"
import script from "./BoxTabularData.vue?vue&type=script&lang=js&"
export * from "./BoxTabularData.vue?vue&type=script&lang=js&"
import style0 from "./BoxTabularData.vue?vue&type=style&index=0&id=cd14f730&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd14f730",
  null
  
)

/* custom blocks */
import block0 from "./BoxTabularData.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxTabularData.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QSeparator,QTable,QInput,QTd,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QSeparator,QTable,QInput,QTd,QInnerLoading,QSpinnerTail})
